import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ResponseNotificationService} from "../../../core/services/response-notification.service";
import {environment} from "../../../../environments/environment";
import {AuthenticationRestService} from "../../../core/services";
import {TokenApiModel} from "../../../api/models/token.api.model";
import {TokenDataProviderService} from "../../../core/services/token-data-provider.service";

@Component({
  selector: 'app-invitation',
  templateUrl: './invitation.component.html',
  styleUrls: ['./invitation.component.scss']
})
export class InvitationComponent implements OnInit {

  private token: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private as: AuthenticationRestService,
    private rns: ResponseNotificationService,
    private tokenDPS: TokenDataProviderService
  ) {
  }

  ngOnInit() {
    this.route.params.subscribe(
      params => {
        this.token = params.token;
      }
    );
    if (this.token && typeof this.token === 'string') {
      const token = new TokenApiModel();
      token.token = this.token;
      this.tokenDPS.loginFromInvitation(token).subscribe(
        successResponse => {
          this.rns.emitMessage(successResponse.message);
          console.log(this.tokenDPS.getJwtUser());
        }
      )
        .add(() => {
          this.router.navigate(['/'])
      });
    }
  }

}
